(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Mythe);

	// Constructor
	function Mythe() {

		// Super constructor
		BaseGame.call(this);

		// Overide audio click sound
		this.clickSound = "audiojungle-20134560-cheeping-frog.wav";

		// Variable to hold data
		this.data = false;
		this.serialSettings = false;

		this.gameInterval = false;
		this.gameEndsAt = 0;
		this.gameDuration = 10;

		// this.users[0].active = false;
		// this.users[1].active = false;
		// this.users[0].score = 0;
		// this.users[1].score = 0;
		// this.users[0].currentAnsusers[1],c = -1;
		// this.currentAnswerP2 = -1;

		this.users = [
			{
				active: false,
				score: 0,
				currentAnswer: -1,
				questionCount: 0,
			},
			{
				active: false,
				score: 0,
				currentAnswer: -1,
				questionCount: 0,
			}
		];

		this.currentQuestions = [];
		this.questionsCount = 10;
		this.currentQuestion = -1;

		// Load data then init
		this.loadData();
	}

	Mythe.prototype.loadData = function () {

		// Load JSON
		var json1 = $.ajax({
			url: "data/mythe.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		}).promise();

		// Load serial settings JSON
		var json2 = $.ajax({
			url: "data/mythe-serial-settings.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.serialSettings = JSON.parse(data.responseText);
			}, this)
		}).promise();


		// Wait for all
		Promise.all([
			json1.promise(),
			json2.promise(),
		]).then($.proxy(function () {
			this.initGame();
		}, this));
	};


	Mythe.prototype.initGame = function () {

		// Shuffle questions and create credits
		this.shuffleQuestions();

		// Init chronocarte beahviour and DOM
		this.initDOM(this.data);

		// Poker switch simulator
		$(".poker-switch").on("click", $.proxy(function (e) {
			var event = $.Event('action');
			event.actionId = $(e.currentTarget).data("action-id");
			$("#game-mythe").trigger(event);
		}, this));

		// Keyboard events
		$("#game-mythe").on("action", $.proxy(function (e) {
			console.log(e.actionId)
			if (e.actionId == "p1-fr" || e.actionId == "p2-fr") {
				// this.start("fr");
				if (this.i18n.lang != "fr") this.i18n.flip();
				if (this.currentScreen == 1) {
					this.goToScreen(2);
				}
			} else if (e.actionId == "p1-en" || e.actionId == "p2-en") {
				// this.start("en");
				if (this.i18n.lang != "en") this.i18n.flip();
				if (this.currentScreen == 1) {
					this.goToScreen(2);
				}
			} else if (e.actionId == "p1-next" || e.actionId == "p2-next") {
				this.next();
			} else if (e.actionId == "p1-home" || e.actionId == "p2-home") {
				this.goToHome();
			} else if (e.actionId == "p1-vrai") {
				this.users[0].currentAnswer = true;
				this.activatePlayer(1);
			} else if (e.actionId == "p1-faux") {
				this.users[0].currentAnswer = false;
				this.activatePlayer(1);
			} else if (e.actionId == "p2-vrai") {
				this.users[1].currentAnswer = true;
				this.activatePlayer(2);
			} else if (e.actionId == "p2-faux") {
				this.users[1].currentAnswer = false;
				this.activatePlayer(2);
			}

		}, this));

		// Start serial server
		if ((typeof process != "undefined")) {
			this.startServers();
			$("#poker-switches").remove();
		}

		// Go to first screen
		this.goToScreen(1);
	};

	Mythe.prototype.activatePlayer = function (p) {
		if (p == 1) {
			this.users[0].active = true;
			$("#player1-score").addClass("active");
		} else if (p == 2) {
			this.users[1].active = true;
			$("#player2-score").addClass("active");
		}

		if (this.users[0].active && this.users[1].active) {
			$("#players-scores").addClass("two-players");
		}
	}

	Mythe.prototype.next = function () {

		if (this.currentScreen == 3) {
			return;
		} else if ((this.currentScreen == 4) && (this.currentQuestion < this.currentQuestions.length - 1)) {
			this.goToScreen(3);
		} else if (this.currentScreen == 6) {
			this.goToScreen(1);
		} else {
			this.goToNextScreen();
		}
	}

	Mythe.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		var actionAccepted = BaseGame.prototype.goToScreen.call(this, screenId, callback);

		if (actionAccepted) {
			// On specific screens, make specific actions
			if (screenId == 1) {
				this.reset();
			} else if (screenId == 2) {
				this.shuffleQuestions();
				$("#players-scores").removeClass("shown");
			} else if (screenId == 3) {
				this.loadQuestion();
				$("#players-scores").addClass("shown");
			} else if (screenId == 4) {
				this.loadAnswer();
				$("#players-scores").addClass("shown");
			} else if (screenId == 5) {
				this.loadScore();
				$("#players-scores").removeClass("shown");
			}
		}
	}


	Mythe.prototype.initDOM = function () {
		// Duplicate score screen
		var duplicateScoreScreen = $("#screen-5 .score-wrapper").clone();
		duplicateScoreScreen.attr("id", "p2-score");
		$("#screen-5").append(duplicateScoreScreen);
	}

	Mythe.prototype.start = function (lang) {

		// Set language
		if (this.i18n.lang != lang) {
			this.i18n.flip();
		}

		// Go to screen 2 if game is not already starter
		if (this.currentScreen <= 1) {
			this.goToScreen(2);
		}
	}

	Mythe.prototype.shuffleQuestions = function () {

		this.currentQuestions = shuffle(this.data["questions"]).slice(0, this.questionsCount);

		// Create credits page
		var credits = [];
		$.each(this.currentQuestions, function (i, n) {
			if (n["question"].credits) {
				credits.push({
					img: n["question"].img_credits,
					label: n["question"].credits
				});
			}
			if (n["answer"].credits) {
				credits.push({
					img: n["answer"].img_credits,
					label: n["answer"].credits
				});
			}
		});
		BaseGame.prototype.createCredits.call(this, credits);
	}

	Mythe.prototype.loadQuestion = function () {

		this.currentQuestion++;

		var question = this.currentQuestions[this.currentQuestion];

		$("#screen-3 .question-wrapper .question .fr").html(question["question"]["fr"]);
		$("#screen-3 .question-wrapper .question .en").html(question["question"]["en"]);
		$("#screen-3 .image-wrapper img").attr("src", "");

		requestAnimationFrame(function () {
			$("#screen-3 .image-wrapper img").attr("src", question["question"]["img"]);
		});

		this.users[0].currentAnswer = -1;
		this.users[1].currentAnswer = -1;
		this.gameEndsAt = millis() + (this.gameDuration * 1000 + 999);
		this.clearGameInterval();
		this.gameInterval = requestInterval($.proxy(this.gameUpdateTimer, this), 100);
		this.gameUpdateTimer();
	}

	Mythe.prototype.loadAnswer = function () {

		// Stop timer check interval
		this.clearGameInterval();

		var question = this.currentQuestions[this.currentQuestion];
		$("#screen-4 .answer-wrapper .answer .fr").html(question["answer"]["fr"]);
		$("#screen-4 .answer-wrapper .answer .en").html(question["answer"]["en"]);
		$("#screen-4 .image-wrapper img").attr("src", "");

		requestAnimationFrame(function () {
			$("#screen-4 .image-wrapper img").attr("src", question["answer"]["img"]);
		});


		// Set true/false class
		$("#screen-4 .title").removeClass("false true").addClass(question["correct_answer"].toString());

		// console.log(this.users[0].currentAnswer, question["correct_answer"], question)

		for (var i = 0; i < this.users.length; i++) {

			// Add score to players
			if (this.users[i].currentAnswer == question["correct_answer"]) {
				this.users[i].score++;
			}

			// Increment question counts and update value
			if (this.users[i].active) {
				this.users[i].questionCount++;
				$("#player" + (i + 1) + "-score").text(this.users[i].score + " / " + this.users[i].questionCount);
			}
		}
	}


	Mythe.prototype.goToAnswer = function () {

		// Stop timer check interval
		this.clearGameInterval();

		// Go to answer screen
		this.goToScreen(4);
	}

	Mythe.prototype.clearGameInterval = function () {

		// Stop timer check interval
		if (this.gameInterval) {
			clearRequestInterval(this.gameInterval);
			this.gameInterval = false;
		}
	}

	Mythe.prototype.gameUpdateTimer = function () {

		var timeLeft = Math.floor((this.gameEndsAt - millis()) / 1000);
		$(".timer-wrapper span").html(Math.max(0, timeLeft));
		if (timeLeft <= 0) {
			this.goToAnswer(true);
		}
	}

	Mythe.prototype.loadScore = function () {

		// Toggle one/two class
		$("#screen-5").toggleClass("two-players", (this.users[0].active && this.users[1].active))

		// Go through players to set score properties
		for (var i = 0; i < this.users.length; i++) {

			// Is active
			$("#screen-5 #p" + (i + 1) + "-score").toggleClass("is-active", this.users[i].active);

			// Thumbs
			var playerPercentageScore = (this.users[i].questionCount != 0) ? this.users[i].score / this.users[i].questionCount : 0;
			$("#screen-5 #p" + (i + 1) + "-score").removeClass("score-low score-medium score-high");
			if (playerPercentageScore >= 0.9) {
				$("#screen-5 #p" + (i + 1) + "-score").addClass("score-high");
			} else if (playerPercentageScore >= 0.6) {
				$("#screen-5 #p" + (i + 1) + "-score").addClass("score-medium");
			} else {
				$("#screen-5 #p" + (i + 1) + "-score").addClass("score-low");
			}

			// Score value
			$("#screen-5 #p" + (i + 1) + "-score .score span").text(this.users[i].score + " / " + this.users[i].questionCount)

			// Remove is first class
			$("#screen-5 #p" + (i + 1) + "-score").removeClass("is-first");
		}

		// Add is first
		// if (this.users[0].score >= this.users[1].score) {
		// 	$("#screen-5 #p1-score").addClass("is-first");
		// }
		// if (this.users[1].score >= this.users[0].score) {
		// 	$("#screen-5 #p2-score").addClass("is-first");
		// }
	}

	Mythe.prototype.startServers = function () {

		// Load serial port library
		var SerialPort = require("serialport");

		// List available ports
		var serialsToUse = [];

		SerialPort.list($.proxy(function (err, ports) {

			try {
				ports.forEach(function (port) {

					var id = (typeof port.pnpId != "undefined") ? port.pnpId : port.comName;

					// List available serial ports
					console.log(port.comName + " (" + id + ") available.");

					// If manufacturer contains ARDUINO, make a connection
					if (typeof port.manufacturer != "undefined" && port.manufacturer.toLowerCase().indexOf("arduino") !== -1 && ((typeof app.serialSettings["serials"] == "undefined") || $.inArray(id, app.settings["serials"]) != -1)) {
						serialsToUse.push(port.comName);
					}
				});

				if (serialsToUse.length == 0 && ports.length != 0) {
					serialsToUse.push(ports[0].comName);
				}

				// Init serial ports servers
				this.startSerialServers(serialsToUse, SerialPort);

			} catch (err) {
				console.error(err);
			}

		}, this));

	};


	Mythe.prototype.startSerialServers = function (serialPortNames, SerialPort) {

		// Load serial port library
		console.log("serial port to create", serialPortNames);

		this.serialports = [];

		var serialButttonMap = Object.values(this.serialSettings["serial-buttons-map"]);
		var serialButttonMapKeys = Object.keys(this.serialSettings["serial-buttons-map"]);

		// Go through each defined serial port
		for (var i = 0; i < serialPortNames.length; i++) {

			// Create an instance to each port defined in settings.json
			this.serialports.push(new SerialPort(serialPortNames[i], {
				baudRate: 9600,
				autoOpen: false,
				parser: new SerialPort.parsers.Readline("\n")
			}));

			console.log('Initializing serial Port using : ' + serialPortNames[i]);

			// Bind events
			this.serialports[i].on('open', $.proxy(function (port) {
				console.log('SerialPort open', port);
			}, this, this.serialports[i]));


			this.serialports[i].on('data', $.proxy(function (port, data) {

				try {
					var receivedString = ("" + data.toString()).trim();
					for (var i = 0; i < serialButttonMap.length; i++) {
						if (receivedString == serialButttonMap[i] + "_PRESS") {
							var actionId = serialButttonMapKeys[i];
							var event = $.Event('action');
							event.actionId = actionId;
							$("#game-mythe").trigger(event);
						}
					}

					this.resetTimer();

				} catch (e) {
					console.log("error", e);
				}

			}, this, this.serialports[i]));

			// Bind events
			this.serialports[i].on('error', $.proxy(function (port, err) {
				console.log('SerialPort error', port, err);
			}, this, this.serialports[i]));

			// Bind events
			this.serialports[i].on('close', $.proxy(function (port) {
				console.log('SerialPort close', port);

				// try to reconnect it
				var reconnect = setInterval($.proxy(function (port) {

					port.open(function (err) {
						console.log("Trying to reopen port...", port);

						if (err) {
							return console.log('Error opening port: ', err.message);
						}
						else {
							clearInterval(reconnect);
							return console.log('Successfully reopened port!', port);
						}
					});

				}, this, port), 5000);

			}, this, this.serialports[i]));

			// Bind events
			this.serialports[i].on('disconnect', $.proxy(function (port) {
				console.log('SerialPort disconnect', port);
			}, this, this.serialports[i]));
		}

		// Go through each defined serial port and open connections
		for (var i = 0; i < serialPortNames.length; i++) {
			this.serialports[i].open(function (err) {
				if (err) {
					return console.log('Error opening port: ', err.message);
				}
				// Because there's no callback to write, write errors will be emitted on the port:
				// this.serialports[i].write('main screen turn on');
			});
		}

	}

	Mythe.prototype.goToHome = function () {
		if (this.currentScreen != 2) {
			this.reset(2);
		}
	}

	Mythe.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset(1);
		}
	}

	Mythe.prototype.reset = function (destinationScreen) {

		// Stop timeouts
		this.clearGameInterval();

		// Reset
		this.currentQuestion = -1;
		for (var i = 0; i < this.users.length; i++) {
			this.users[i].active = false;
			this.users[i].score = 0;
			this.users[i].currentAnswer = -1;
			this.users[i].questionCount = 0;
		}

		$("#players-scores").removeClass("shown two-players");
		$("#player1-score").text("0 / 0").removeClass("active");
		$("#player2-score").text("0 / 0").removeClass("active");

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Go to screen and clear
		this.goToScreen(destinationScreen, $.proxy(function () {

			// Reset and clean things up
			if (this.i18n.lang != "fr" && destinationScreen == 1) {
				this.i18n.flip();
			}

		}, this));
	}

	// Expose Mythe
	window.Mythe = Mythe;

})(jQuery, Promise);